import React, { useState, useEffect, useReducer, Dispatch } from "react";
import Styles from "../../styles/sorting/SortingScreen.module.css";
import BannerComponent from "../../components/BannerComponent";
import SortingGraphComponent from "../../components/Sorting/SortingGraphComponent";
import SortingDescriptionComponent from "../../components/Sorting/SortingDescriptionComponent";
import SortingAlgoComponent from "../../components/Sorting/SortingAlgoComponent";
import Sorting from "../../Algorithms/Sorting";
import CodeViewComponent from "../../components/CodeViewComponent";
import DesHeaderComponent from "../../components/DesHeaderComponent";
import { SORTINGDATA } from "../../Algorithms/SortingData";

type payloadTypes = {
  height: number[];
  si: number;
  ei: number;
};

// SORTING REDUCER
const heightReducer = (
  state: payloadTypes,
  action: {
    type: string;
    payload: payloadTypes;
  }
): { height: number[]; si: number; ei: number } => {
  // console.log(action.payload);
  switch (action.type) {
    case "UPDATE":
      return {
        height: [...action.payload.height],
        si: action.payload.si,
        ei: action.payload.ei,
      };
    default:
      return { height: state.height, si: state.si, ei: state.ei };
  }
};

// SORTING SCREEN
const SortingScreen: React.FC = () => {
  const [algoName, setAlgoName] = useState("BUBBLE SORT");
  const [startAnimation, setStartAnimation] = useState(false);
  const [tab1Visible, setTab1Visible] = useState(true);
  const [sortingDes, setSortingDes] = useState({});

  useEffect(() => {
    console.log(algoName);
    refresh();
    setStartAnimation(false);

    switch (algoName) {
      case "BUBBLE SORT":
        setSortingDes(SORTINGDATA[0].BUBBLE_SORT);
        break;
      case "INSERTION SORT":
        setSortingDes(SORTINGDATA[0].INSERTION_SORT);
        break;
      case "SELECTION SORT":
        setSortingDes(SORTINGDATA[0].SELECTION_SORT);
        break;
      case "SHELL SORT":
        setSortingDes(SORTINGDATA[0].SHELL_SORT);
        break;
      case "HEAP SORT":
        setSortingDes(SORTINGDATA[0].HEAP_SORT);
        break;
      case "MERGE SORT":
        setSortingDes(SORTINGDATA[0].MERGE_SORT);
        break;
      case "QUICK SORT":
        setSortingDes(SORTINGDATA[0].QUICK_SORT);
        break;
      default:
        setSortingDes(SORTINGDATA[0].BUBBLE_SORT);
        break;
    }
  }, [algoName]);

  const generateRandomArray = (): number[] => {
    let arr: number[] = [];
    for (let i: number = 0; i < 15; i++) {
      arr.push((Math.floor(Math.random() * 10) + 1) * 10);
    }
    return arr;
  };

  const playAnimation = (): void => {
    setStartAnimation(!startAnimation);
    refresh();
    callSorting(algoName);
  };

  const [height, setHeight]: [
    payloadTypes,
    Dispatch<{
      type: string;
      payload: payloadTypes;
    }>
  ] = useReducer(heightReducer, {
    height: generateRandomArray(),
    si: 0,
    ei: 1,
  });

  const callSorting = (algName: string): void => {
    console.log("calling sorting");
    const sorting = new Sorting(setHeight);
    switch (algName) {
      case "BUBBLE SORT":
        setSortingDes(SORTINGDATA[0].BUBBLE_SORT);
        sorting.BubbleSort(height.height);
        break;
      case "INSERTION SORT":
        setSortingDes(SORTINGDATA[0].INSERTION_SORT);
        sorting.InsertionSort(height.height);
        break;
      case "SELECTION SORT":
        console.log("selection----------------------------------------");
        setSortingDes(SORTINGDATA[0].SELECTION_SORT);
        console.log(SORTINGDATA[0].SELECTION_SORT);
        sorting.SelectionSort(height.height);
        break;
      case "SHELL SORT":
        sorting.ShellSort(height.height);
        break;
      case "HEAP SORT":
        sorting.HeapSort(height.height);
        break;
      case "MERGE SORT":
        let arrayM: number[] = [...height.height];
        sorting.MergeSort(arrayM);
        break;
      case "QUICK SORT":
        let arrayQ: number[] = [...height.height];
        sorting.quickSort(arrayQ, 0, arrayQ.length - 1);
        break;
      default:
        sorting.BubbleSort(height.height);
    }
  };

  const refresh = (): void => {
    setHeight({
      type: "UPDATE",
      payload: { height: generateRandomArray(), si: 0, ei: 1 },
    });
  };

  return (
    <div className={Styles.container}>
      {/* <BannerComponent header={"SORTING"} /> */}
      <SortingAlgoComponent setAlgoName={setAlgoName} />

      <div className={Styles.sortingContainer}>
        <SortingGraphComponent
          height={height}
          refresh={refresh}
          playAnimation={playAnimation}
        />

        <div className={Styles.description}>
          <DesHeaderComponent setTab1Visible={setTab1Visible} />
          {tab1Visible ? (
            <SortingDescriptionComponent {...sortingDes} />
          ) : (
            <CodeViewComponent {...sortingDes} />
          )}
        </div>
      </div>
    </div>
  );
};

export default SortingScreen;
